import { render, staticRenderFns } from "./DeleteTestBuilderTestButton.vue?vue&type=template&id=015389ed&"
import script from "./DeleteTestBuilderTestButton.vue?vue&type=script&lang=js&"
export * from "./DeleteTestBuilderTestButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports